import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TextField } from "@mui/material";
import userManualService from "../../../services/userManual";
import { instanceToken } from "../../../utils/constant";
import {
  EditPageLayout,
  EditFieldLabel,
} from "../../../components/edit/EditPageLayout";

export default function UpdateUserManual({ homeAlert }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [question, setQuestion] = useState("");
  const [questionMM, setQuestionMM] = useState("");
  const [answers, setAnswers] = useState([{ answer_en: "", answer_mm: "" }]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    async function fetchManual() {
      const response = await userManualService.getUserManual(
        instanceToken.token,
        id
      );
      setAnswers(response?.data?.answers || [{ answer_en: "", answer_mm: "" }]);
      setQuestion(response?.data?.question_en || "");
      setQuestionMM(response?.data?.question_mm || "");
    }
    fetchManual();
  }, [id]);

  const handleAddAnswer = () => {
    setAnswers([...answers, { answer_en: "", answer_mm: "" }]);
  };

  const handleAnswerChange = (index, field, value) => {
    const updatedAnswers = [...answers];
    updatedAnswers[index][field] = value;
    setAnswers(updatedAnswers);
  };

  const handleRemoveAnswer = (index) => {
    const updatedAnswers = [...answers];
    updatedAnswers.splice(index, 1);
    setAnswers(updatedAnswers);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const err = {};

    if (!question.trim()) err.question = "Title is required";
    if (
      answers.some(
        (answer) => !answer.answer_en.trim() || !answer.answer_mm.trim()
      )
    ) {
      err.answers = "All answer fields must be filled";
    }

    if (Object.keys(err).length > 0) {
      setErrors(err);
      return;
    }

    try {
      setLoading(true);
      await userManualService.updateUserManual(instanceToken.token, id, {
        question_mm: questionMM,
        question_en: question,
        answers,
      });
      homeAlert("User Manual has been updated.", false);
      navigate("/user-manual");
    } catch (error) {
      homeAlert("Failed to update User Manual!", true);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <EditPageLayout
      title="Edit User Manual"
      subtitle="Update user manual entry details."
      breadcrumbs={[
        { label: "User Manual", path: "/user-manual" },
        { label: `User Manual (ID - ${id})`, path: `/user-manual/${id}` },
        { label: "Edit" },
      ]}
      detailPath={`/user-manual/${id}`}
      listPath="/user-manual"
      loading={loading}
      submitLabel="Update"
      onSubmit={handleUpdate}
    >
      <div className="edit-form-row-2">
        <div>
          <EditFieldLabel required>Title (English)</EditFieldLabel>
          <TextField
            fullWidth
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            error={!!errors.question}
            helperText={errors.question}
          />
        </div>
        <div>
          <EditFieldLabel>Title (Myanmar)</EditFieldLabel>
          <TextField
            fullWidth
            value={questionMM}
            onChange={(e) => setQuestionMM(e.target.value)}
            error={!!errors.questionMM}
            helperText={errors.questionMM}
          />
        </div>
      </div>

      <div className="edit-form-answers">
        <div className="edit-form-answers-head">
          <h3 className="edit-form-answers-title">Answers</h3>
          <button
            type="button"
            className="edit-btn edit-btn-back"
            onClick={handleAddAnswer}
          >
            + Add Answer
          </button>
        </div>
        {errors.answers && (
          <p className="edit-field-error">{errors.answers}</p>
        )}
        {answers.map((answer, index) => (
          <div key={index} className="edit-form-answer-row">
            <div>
              <EditFieldLabel required>Answer EN {index + 1}</EditFieldLabel>
              <TextField
                fullWidth
                value={answer.answer_en}
                onChange={(e) =>
                  handleAnswerChange(index, "answer_en", e.target.value)
                }
                error={!!errors.answers}
              />
            </div>
            <div>
              <EditFieldLabel required>Answer MM {index + 1}</EditFieldLabel>
              <TextField
                fullWidth
                value={answer.answer_mm}
                onChange={(e) =>
                  handleAnswerChange(index, "answer_mm", e.target.value)
                }
                error={!!errors.answers}
              />
            </div>
            {answers.length > 1 && (
              <button
                type="button"
                className="edit-btn edit-btn-remove-outline"
                onClick={() => handleRemoveAnswer(index)}
              >
                Remove
              </button>
            )}
          </div>
        ))}
      </div>
    </EditPageLayout>
  );
}
